import {Archive} from '../types/Archive';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class ArchivesService {
  public async getAllArchives(): Promise<Archive[]> {
    return handleError(
      () => httpClient.get<Archive[]>('/archives'),
      'Error fetching archives:',
      () => []
    );
  }

  public async getArchive(id: string): Promise<Archive> {
    return handleError(
      () => httpClient.get<Archive>(`/archives/${id}`),
      'Error fetching archive:'
    );
  }

  public async createArchive(archive: Omit<Archive, 'id'>): Promise<void> {
    const archiveWithId = {
      ...archive,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/archives', archiveWithId),
      'Error creating archive:'
    );
  }

  public async updateArchive(archive: Archive): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/archives/${archive.id}`, archive),
      'Error updating archive:'
    );
  }

  public async deleteArchive(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/archives/${id}`),
      'Error deleting archive:'
    );
  }

  public async importArchives(publicationId: string, csvContent: string): Promise<void> {
    return handleError(
      () => httpClient.post<void>('/archives/import', { publicationId, csvContent }),
      'Error importing archives:'
    );
  }
}

const archivesService = new ArchivesService();
export default archivesService;

